import React from "react";
import { store } from '../../redux/store';
import { showRblOtpVerifySection } from '../../redux/div-show-and-hide/div-show-and-hide.action';
import { setRblUniqueRefNo } from '../../redux/on-boarding/on-boarding.action';
import apiCallService from '../../service/api-call-service';
import { connect } from 'react-redux';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import XMLParser from 'react-xml-parser';
import $ from 'jquery';

var finalUrl = "";
var MethodInfo = "";
var MethodCapture = "";
var finalport = "";
var is_capture = false;
var finalRdServiceResponse = [];
var deviceInfo = '';

class Biometric extends React.Component{
    constructor(props){
        super(props);
        this.state={
            messagePopUpHidden: false,
            message: '',
            severity: '',
            biomatricDeviceIndicaterClass:'',
            RDdeviceInfo: '',
            isBiomatricConnected: false,
            CaptureFingerprintData: '',
        }
    }

    componentDidMount = async () => {

		const requestToSend = {
            "request": {
                "userid": process.env.REACT_APP_On_Boarding_Rbl_Ott_User_Id,
                "password": process.env.REACT_APP_On_Boarding_Rbl_Ott_Pwd,
                "bcagentid": process.env.REACT_APP_On_Boarding_Rbl_Ott_Bcagent_Id,
                "cpuniquerefno": this.props.uniqueRefNo
            }
        }

        console.log('Rbl Unique Refno Request ',requestToSend);

        const rblUniqueRefnoUrl = process.env.REACT_APP_On_Boarding_Rbl_unique_refNo_Url;

        console.log('Rbl Unique Refno Url ',rblUniqueRefnoUrl);

        const response = await apiCallService.postMethodCall(rblUniqueRefnoUrl, requestToSend);

        console.log('Rbl Unique Refno Response ',response)

        if (!(response === undefined) && (response.response_code == 0)) {
            store.dispatch(setRblUniqueRefNo({rblUniqueRefNo:response.response.rbluniquerefno}));
           
            this.setState({ messagePopUpHidden: true });
			this.setState({ severity: "success" });
            this.setState({message:response.response.statusMessage});          
		}
		else if (!(response === undefined) && !(response.response_description === undefined)) {
			this.setState({ messagePopUpHidden: true });
			this.setState({ severity: "error" });
			this.setState({ message: response.response_description });		
		} else {
			this.setState({ messagePopUpHidden: true })
			this.setState({message:response});
			this.setState({ severity: "error" });
		}

        setInterval(()=>{
            
                this.findbiomatricDevice();
            
            }, 9000);
	}

    findbiomatricDevice = ()=>{
        var discoverRDServiceResponse =  this.discoverRDService();
        var discoverRDServiceFinalResponse = new XMLParser().parseFromString(discoverRDServiceResponse.data);
        var info = discoverRDServiceFinalResponse!=undefined && discoverRDServiceFinalResponse.attributes.info!=undefined? discoverRDServiceFinalResponse.attributes.info:'';
        var status = discoverRDServiceFinalResponse!=undefined && discoverRDServiceFinalResponse.attributes.status!=undefined? discoverRDServiceFinalResponse.attributes.status:'';
        if(status=="NOTREADY"){
            this.setState({biomatricDeviceIndicaterClass:"disconnect"});
        }else{
         this.setState({biomatricDeviceIndicaterClass:"connect"});
        }
        this.setState({ biomatricDeviceIndicater: info }); 
        console.log("BiomatricDeviceIndicaterClass : "+this.state.biomatricDeviceIndicaterClass);
    }

    discoverRDService = () => {				
        var primaryUrl = process.env.REACT_APP_RDService_URL;
        var tempcount = 0;
        var url = "";
        $("#ddlRDS").empty();
        
        for (var i = 11100; i <= 11120; i++) {
            var verb = "RDSERVICE";
            var err = "";
            var res;
            $.support.cors = true;
            var httpStaus = false;
            var jsonstr = "";
            var data = new Object();
            var obj = new Object();
            var xmlstr;

            $.ajax({
                type: "RDSERVICE",
                async: false,
                crossDomain: true,
                url: primaryUrl + i.toString(),
                contentType: "text/xml; charset=utf-8",
                processData: false,
                cache: false,
                async: false,
                crossDomain: true,

                success: function (data) {
                    try {
                        xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                        data = xmlstr;

                        httpStaus = true;
                        res = { httpStaus: httpStaus, data: data };		
                        finalUrl = primaryUrl + i.toString();

                        var $doc = $.parseXML(xmlstr);
                        var CmbData1 = $($doc).find('RDService').attr('status');
                        var CmbData2 = $($doc).find('RDService').attr('info');

                        $("#ddlRDS").append('<option value=' + i.toString() + '>Port : ' + i.toString() + ' Status : ' + CmbData1 + '(' + CmbData2 + ')</option>')
                        tempcount++;
                    }
                    catch (e) { }
                },
                error: function (msg) {
                    var result = msg.status + msg.statusText + msg.responseText;
                    res = { httpStaus: false, data: data };
                }
               
            });

            if (xmlstr != null) {
                if (xmlstr.indexOf('Precision') > 0) {
                    
                    $("select#ddlRDS").prop('selectedIndex', tempcount - 1);
                    finalport = i.toString();
                    this.discoverFirstNode(i);
                    break;
                }
            }
        }
        return res;
    }

    discoverFirstNode = (PortNo) => {
        $('#txtDeviceInfo').val('');
        $('#txtPidOptions').val('');
        $('#txtPidData').val('');

        var primaryUrl = process.env.REACT_APP_RDService_URL;
        let url = "";
        var verb = "RDSERVICE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        var data = new Object();
        var obj = new Object();

        $.ajax({
            type: "RDSERVICE",
            async: false,
            crossDomain: true,
            url: primaryUrl + PortNo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            cache: false,
            async: false,
            crossDomain: true,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);                
                data = xmlstr;                 
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };                		
                $('#txtRDSInfo').val(data);

                var $doc = $.parseXML(data);

                for (var j = 0; j < 2; j++) {
                    if ($($doc).find('Interface').eq(j).attr('id') == 'CAPTURE') {
                        MethodCapture = $($doc).find('Interface').eq(j).attr('path');
                    } else if ($($doc).find('Interface').eq(j).attr('id') == 'DEVICEINFO') {
                        MethodInfo = $($doc).find('Interface').eq(j).attr('path');
                    }
                } 

                console.log("Precision RDSERVICE Discover Successfully");
                var parser = new DOMParser();
                var device1_response = parser.parseFromString($doc, "text/xml");
                is_capture = true;
            },
            error: function (msg) {
                is_capture = false;
                var result = msg.status + msg.statusText + msg.responseText;
                alert(result);

            }
        });
        this.deviceInfo();
       
        return res;
    }

    deviceInfo = () => {
        var url = "";
        finalUrl = process.env.REACT_APP_RDService_URL + finalport;
        var verb = "DEVICEINFO";
        var err = "";
        var res;
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "DEVICEINFO",
            async: false,
            crossDomain: true,
            url: finalUrl + MethodInfo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                data = xmlstr;
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };

                $('#txtDeviceInfo').val(data);
                deviceInfo = data;
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                console.log("Error In device info", result);

            }
        });
        var RDdeviceInfoXml = new XMLParser().parseFromString(deviceInfo);
        this.setState({ RDdeviceInfo: RDdeviceInfoXml })
        return res;
    }

    capture = (event) => {

        var fCount = document.getElementById('txtfcount').value;
        var fType = document.getElementById('txtftype').value;
        var format = document.getElementById('txtformat').value;
        var pidver = document.getElementById('txtPidVer').value;
        var timeout = document.getElementById('txttimeout').value;
        var env = document.getElementById('txtenv').value;
        var lock = document.getElementById('txtlk').value;

        finalUrl = process.env.REACT_APP_RDService_URL + finalport;
        console.log("Capture Url : ", finalUrl);
        var XML = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="' + fCount + '" fType="' + fType + '" format="' + format + '" pidVer="' + pidver + '" timeout="' + timeout + '" env="' + env + '" /> <CustOpts> <Param name="LockingKey" value="' + lock + '" /> </CustOpts> </PidOptions>';
        console.log("XML_data_", XML);
        var verb = "CAPTURE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "CAPTURE",
            async: false,
            crossDomain: true,
            url: finalUrl + MethodCapture,
            data: XML,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                data = xmlstr;
                httpStaus = true;
                var isBiomatric = true;
                res = { httpStaus: httpStaus, data: data };
                finalRdServiceResponse = data;
                $('#txtPidData').val(data);
                $('#txtPidOptions').val(XML);

                var $doc = $.parseXML(data);
                var Message = $($doc).find('Resp').attr('errInfo');
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                res = { httpStaus: false, data: result };
                alert("Please reconnect biometric device.")

                console.log("Error in Finger print capture ", res);

            }
        });
        this.setState({ isBiomatricConnected: false });
     
        return res;
    }

    submitFormData = async () => {
    
      console.log('tested submit function');
      setTimeout(() => {
        if (is_capture == true) {
            var captureData = this.capture();
            console.log("Capture Data : ",captureData);
            var Fingerprintxml = new XMLParser().parseFromString(captureData.data);
            var errCode  = Fingerprintxml.children[0].attributes.errCode!=undefined?Fingerprintxml.children[0].attributes.errCode:'';
            console.log("Fingerprintxml data : ",Fingerprintxml.children[0].attributes.errCode);
            if(errCode == 0){
                this.setState({ CaptureFingerprintData: Fingerprintxml });
                store.dispatch(showRblOtpVerifySection());
                
                this.setState({ messagePopUpHidden: true })
                this.setState({message:"Finger Print capture successfully."});
                this.setState({ severity: "success" });
                    
            }else{
                var errInfo = Fingerprintxml.children[0].attributes.errInfo!=undefined?Fingerprintxml.children[0].attributes.errInfo:'';
                Fingerprintxml=[];
                this.setState({ messagePopUpHidden: true })
                this.setState({message:errInfo});
                this.setState({ severity: "error" });
            }
            console.log("CaptureFingerprintDataResponse : ", JSON.stringify(this.state.CaptureFingerprintData));
            console.log("Fingerprintxml : ", Fingerprintxml);
        }

    }, 300);
    }
      render(){
          return(
              <>
                <div style={{ display: 'none' }} >
                    <input type="hidden" value="1" id="txtfcount" class="form-control" />
                    <input type="hidden" value="0" id="txtftype" class="form-control" />
                    <input type="hidden" value="0" id="txtformat" class="form-control" />
                    <input type="hidden" value="2.0" id="txtPidVer" class="form-control" />
                    <input type="tehiddenxt" value="10000" id="txttimeout" class="form-control" />
                    <input type="hidden" value="P" id="txtenv" class="form-control" />
                    <input type="hidden" value="" id="txtlk" class="form-control" />
                    <textarea id="txtRDSInfo" class="form-control hide"> </textarea>
                    <textarea id="txtDeviceInfo" class="form-control hide"> </textarea>
                    <textarea id="txtPidData" class="form-control hide"> </textarea>
                    <select id="ddlRDS" class="form-control hide"  ><option></option></select>
                </div>
            <div className="mid-contant">
            <div className="container">		
                <div className="row">
                    <div className="col-12">
                        <div className="head">
                            <div className="step">
                                <ul>
                                    <li className="basic done">										
                                        <i className="dot"></i>
                                        <i className="line"></i>
                                        <span className="litxt">Basic</span>
                                    </li>
                                    <li className="bioscan">										
                                        <i className="dot"></i>
                                        <i className="line"></i>
                                        <span className="litxt">Biomatric</span>
                                    </li>
                                    <li className="otp">							
                                        <i className="dot"></i>
                                        <i className="line"></i>
                                        <span className="litxt">OTP</span>
                                    </li>						
                                </ul>					
                            </div>
                            <h2>Scan Biometric</h2>
                        </div>
                    </div>
                    
                    <Snackbar
                       anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
					   open={this.state.messagePopUpHidden}
					   autoHideDuration={3000}
					   onClose={e => this.setState({ messagePopUpHidden: false })}
				    >
					   <Alert onClose={e => this.setState({ messagePopUpHidden: false })} severity={this.state.severity}>
						  {this.state.message}
					    </Alert>
				    </Snackbar>

                    <div className="col-12">
                        <div className="registerbox">
                            <form  autocomplete="off">
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <div className="biometric">
                                            <i className="scanner"></i>									
                                            <p>Connect biometric device to laptop / mobile and scan fingerprint for Full KYC authenticating.</p>									
                                            <button type="button" className="btn btn-primary" id="" onClick={this.submitFormData}>Scan Now</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        </>                         
        );
      } 
}

const mapStateToProps = ({ onBoarding: {uniqueRefNo} }) => ({
    uniqueRefNo
});

export default connect(mapStateToProps, null)(Biometric);